module.exports = __webpack_public_path__ + "img/1_004.6e89797c.jpg";